/* global theme */
if (!customElements.get('cart-note')) {
  let lastSavedValue;
  let pendingSave = null;
  let debounceTimer = null;
  let submittingAfterFlush = false;

  function getNoteTextareaForForm(form) {
    if (form.id === 'cart-drawer-form') {
      return document.getElementById('cart-note-drawer')
        || form.closest('cart-drawer')?.querySelector('cart-note textarea');
    }
    if (form.id === 'cart') {
      return document.getElementById('cart-note-page')
        || form.querySelector('cart-note textarea');
    }
    return null;
  }

  async function saveCartNote(value) {
    const note = value ?? '';

    if (note === lastSavedValue) {
      return pendingSave || Promise.resolve();
    }

    if (pendingSave) {
      await pendingSave;
      if (note === lastSavedValue) return;
    }

    pendingSave = fetch(theme.routes.cartUpdate, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ note })
    }).then((response) => {
      if (!response.ok) throw new Error('Cart note save failed');
      lastSavedValue = note;
    }).finally(() => {
      pendingSave = null;
    });

    return pendingSave;
  }

  function flushCartNote(value) {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
      debounceTimer = null;
    }
    return saveCartNote(value ?? '');
  }

  function initCheckoutNoteFlush() {
    if (window.__cartNoteCheckoutInit) return;
    window.__cartNoteCheckoutInit = true;

    document.addEventListener('submit', async (evt) => {
      if (submittingAfterFlush) return;

      const form = evt.target;
      if (!form || (form.id !== 'cart' && form.id !== 'cart-drawer-form')) return;
      if (!evt.submitter || evt.submitter.name !== 'checkout') return;

      const textarea = getNoteTextareaForForm(form);
      if (!textarea) return;

      evt.preventDefault();

      try {
        await flushCartNote(textarea.value);
      } catch (error) {
        console.log(error); // eslint-disable-line
      }

      submittingAfterFlush = true;
      form.requestSubmit(evt.submitter);
      submittingAfterFlush = false;
    });
  }

  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.closest('details');

      if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
        this.cartNoteToggle = this.disclosure.querySelector('.js-show-note');
      }

      this.init();
    }

    init() {
      this.textarea = this.querySelector('textarea');
      if (!this.textarea) return;

      if (lastSavedValue === undefined) {
        lastSavedValue = this.textarea.value;
      }

      this.handleInput = this.handleInput.bind(this);
      this.handleBlur = this.handleBlur.bind(this);

      this.textarea.addEventListener('input', this.handleInput);
      this.textarea.addEventListener('blur', this.handleBlur);

      initCheckoutNoteFlush();
    }

    handleInput() {
      this.updateToggleLabel(this.textarea.value);

      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        debounceTimer = null;
        saveCartNote(this.textarea.value);
      }, 300);
    }

    handleBlur() {
      flushCartNote(this.textarea.value);
    }

    updateToggleLabel(value) {
      if (!this.cartNoteToggle) return;

      const label = value ? theme.strings.editCartNote : theme.strings.addCartNote;
      if (this.cartNoteToggle.textContent !== label) {
        this.cartNoteToggle.textContent = label;
      }
    }
  }

  customElements.define('cart-note', CartNote);
}
